import * as React from "react";
import PropTypes from 'prop-types';

const SvgValentinesDay = props => {
  if (props.id !== "_svgvalentinesday") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 88 88" {...props}><g fill="none" fillRule="evenodd"><circle cx={43.819} cy={43.819} fill="#de1118" r={37.819} /><path d="M70.56 26.864c-8.78-11.36-26.059-4.657-26.059 6.88 0-11.537-17.28-18.241-26.06-6.88C9.364 38.608 18.31 59.182 44.5 71c26.19-11.818 35.135-32.392 26.06-44.136z" fill="#fea2bc" fillRule="nonzero" /><path d="M31.609 63.557l42.295-24.42a23.18 23.18 0 01-1.035 4.875L34.995 65.88a63.906 63.906 0 01-3.386-2.322zM16.882 29.293l14.299-8.256c1.804.127 3.567.571 5.189 1.281L15.19 34.546a16.45 16.45 0 011.692-5.253zm.12 17.038l27.081-15.636c.272.968.418 1.988.418 3.048 0-1.277.212-2.495.6-3.636l15.585-8.998c1.646.2 3.282.684 4.833 1.487L18.661 49.649a31.388 31.388 0 01-1.66-3.318zm3.672 6.433l48.162-27.807a16.596 16.596 0 012.42 2.88l-48.26 27.862c-.84-.97-1.614-1.95-2.322-2.935zm4.929 5.707l47.338-27.33c.446 1.2.751 2.453.915 3.748l-45.38 26.2a52.51 52.51 0 01-2.873-2.618zm13.032 9.583L70.252 49.8c-1.501 2.582-3.45 5.156-5.847 7.652L42.533 70.08a75.937 75.937 0 01-3.898-2.026zM15.073 38.89L39.96 24.522a13.35 13.35 0 012.553 2.803l-26.75 15.444a22.399 22.399 0 01-.69-3.879z" fill="#ff7ba0" /></g></svg>;
};

SvgValentinesDay.displayName = "_svgvalentinesday";
SvgValentinesDay.propTypes = {
  id: PropTypes.string
};
SvgValentinesDay.defaultProps = {
  id: ''
};
export default SvgValentinesDay;